export default {
    correct_answers: "Réponses correctes",
    drag_and_drop: "Glisser déposer",
    drag_the_words_description: "Le joueur doit choisir les mots disponibles et les faire glisser vers le champ de mot dans le texte, jusqu'à ce que tous les mots disponibles soient utilisés.",
    drag_the_words_failure_message: "Dommage, vous ne l'avez pas fait. Réessayer!",
    drag_the_words_instructions: "Vous verrez un texte avec des espaces vides et un champ avec des mots parmi lesquels choisir. Vous devez faire glisser les mots dans les blancs jusqu'à ce qu'il n'y ait plus de mots dans vos options.",
    drag_the_words_success_message: "Félicitations, vous avez bien compris tous les mots et terminé le jeu!",
    drag_the_words: "Faites glisser les mots",
    enigma_failure_message: "Dommage que vous n'ayez pas réussi. Réessayer.",
    enigma_instructions: "Voir les astuces et résoudre les énigmes!",
    enigma_success_message: "Félicitations, vous avez réussi à suivre correctement les indices et à résoudre l'énigme!",
    enigma: "L'énigme",
    errors: "Les erreurs",
    example: "Exemple",
    fill_in_the_blanks_failure_message: "Dommage, vous ne l'avez pas fait. Réessayer!",
    fill_in_the_blanks_instructions: "Le joueur doit remplir tous les espaces vides dans le texte. Lorsqu'il remplit tous les espaces, le joueur doit cliquer sur soumettre pour que le jeu se termine.",
    fill_in_the_blanks_success_message: "Félicitations, vous avez bien compris tous les mots et terminé le jeu!",
    fill_in_the_blanks: "Remplir les espaces",
    find_the_pairs_failure_message: "Quel dommage, vous avez dépassé la limite d'erreurs autorisées. Réessayer.",
    find_the_pairs_instructions: "Le joueur aura deux colonnes et devra cliquer sur l'une des options d'une colonne, puis cliquer sur l'une des options de la colonne à côté. Le jeu se terminera lorsque toutes les options seront sélectionnées.",
    find_the_pairs_success_message: "Félicitations, vous avez réussi à trouver les paires correctement !",
    find_the_pairs: "Trouve les paires",
    flashcards_failure_message: "Dommage, tu n'y es pas parvenu. Réessayer.",
    flashcards_instructions: "Le joueur doit ajouter une réponse à chaque flashcard, jusqu'à ce qu'il termine le jeu.",
    flashcards_success_message: "Félicitations, vous avez tous les bons flashcards !",
    flashcards: "Flashcards",
    forfeit: "Abandonner",
    game_type: "Type de jeu",
    games: "Jeux",
    infinite: "Infini",
    instructions: "Instructions",
    play_again: "Rejouer",
    play: "Jouer",
    qty_errors_allowed: "Nombre d'erreurs autorisées",
    restart: "Redémarrage",
    result: "Résultat",
    that: "Cela",
    this_or_that_failure_message: "Dommage que vous n'ayez pas réussi. Réessayer.",
    this_or_that_instructions: "Le joueur verra une description et devra choisir l'option 'ceci' ou 'cela', jusqu'à ce qu'il coche toutes les options disponibles.",
    this_or_that_success_message: "Félicitations, vous avez bien compris ceci ou cela!",
    this_or_that: "Ceci ou cela",
    this: "Ce",
    tip: "Conseil",
    true_or_false_failure_message: "Dommage que vous n'ayez pas réussi. Réessayer.",
    true_or_false_instructions: "Choisissez l'option vrai ou faux pour chacune des phrases.",
    true_or_false_success_message: "Félicitations, vous avez bien compris Vrai ou Faux!",
    true_or_false: "Vrai ou faux",
    words: "Mots"
}